import HttpEntityClient from '@123/druid/dist/Components/Http/HttpEntityClient';
import {injectable} from '@123/druid/dist/Framework/Decorators/Inject';
import {analyticsScriptSchema, type AnalyticsScript} from '@Module/Tracking/Schema/AnalyticsScript';
import type {UpdateCookieRequest} from '@Module/Tracking/Type/UpdateCookieRequest';

@injectable()
export default class CookieTrackingService {
    constructor(private entityClient: HttpEntityClient = new HttpEntityClient()) {}

    public updateCookiePreferences(body: UpdateCookieRequest): Promise<AnalyticsScript> {
        return this.entityClient.post('/action/update-cookie-preferences.json', body, analyticsScriptSchema);
    }
}
